<background-modal>
    <form [formGroup]="form">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-md-6">
                <h1 i18n>Parent Sign In</h1>
                <div *ngIf="isValidLink">
                    <mat-form-field appearance="fill">
                        <mat-label i18n>Password</mat-label>
                        <input type="password" [type]="hidePassword ? 'password' : 'text'" matInput i18n-placeholder
                            placeholder="Password" formControlName="password" #password />
                        <button mat-icon-button type='button' matSuffix (click)="hidePassword = !hidePassword"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-error i18n *ngIf="form.get('password')?.errors?.['required']">
                            Password is required
                        </mat-error>
                    </mat-form-field>
                    <button class="btn btn-primary" [disabled]="!form.valid" i18n style="width: 100%;"
                        (click)="signIn(password.value)"> Login

                        <!-- (click)="authService.signInAnonym(participantId, parentId, password.value)" -->
                    </button>
                </div>
                <div *ngIf="!isValidLink">
                    <p i18n>It seams like, you have a wrong link.</p>
                    <br><p i18n>Please open the Link from the Email!</p>
                </div>
            </div>
        </div>
    </form>
</background-modal>
